import { mapActions, mapGetters } from 'vuex';

import { roleInCurrentOrganisation } from '@/helpers/guards/roleInMerchant';

export default {
  computed: {
    ...mapGetters({
      userLoaded: 'user/userLoaded',
      userPermissions: 'user/userPermissions',
      currentOrganisation: 'organisation/currentOrganisation',
      incognito: 'user/incognito',
    }),
    // Everybody can view settings but cant edit
    userSettingsAccess() {
      // let permission = false;
      // if (
      //   this.incognito ||
      //   this.isOwner ||
      //   (
      //     this.userPermissions &&
      //     this.userPermissions[this.currentOrganisation.id] &&
      //     this.userPermissions[this.currentOrganisation.id].includes('manage_settings')
      //   )
      // ) {
      //   permission = true;
      // }
      return true;
    },
    isAdmin() {
      return roleInCurrentOrganisation() === 'admin';
    },
    isOwner() {
      return roleInCurrentOrganisation() === 'owner';
    },
  },
  watch: {
    currentOrganisation() {
      // Nothing happens at the moment since all the permissions are loaded on app load or via pusher update.
    },
  },
  mounted() {
    if (!this.userLoaded) {
      this.fetchUser();
    }
  },
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser',
    }),

    checkPermission(permissionToCheck) {
      let permission = false;
      if (
        (
          this.incognito &&
          this.incognito[this.currentOrganisation.id]
        ) ||
        (
          this.userPermissions &&
          this.userPermissions[this.currentOrganisation.id] &&
          this.userPermissions[this.currentOrganisation.id].includes(permissionToCheck)
        )
      ) {
        permission = true;
      }
      return permission;
    },
  },
};
